// Âm báo tin nhắn riêng biệt — tạo bằng Web Audio (2 nốt ngắn), không cần file.
let ctx = null;
export function playMessageSound() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    const now = ctx.currentTime;
    const notes = [
      [880, 0],
      [1175, 0.12],
    ];
    notes.forEach(([freq, t]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + t);
      gain.gain.exponentialRampToValueAtTime(0.25, now + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + t);
      osc.stop(now + t + 0.2);
    });
  } catch {
    /* trình duyệt chưa cho phát âm thanh trước khi tương tác — bỏ qua */
  }
}

// Âm BUZZ! kiểu Yahoo — 2 hồi "bzzt bzzt" trầm, gằn (sawtooth) để giật mình chú ý.
export function playBuzzSound() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    const now = ctx.currentTime;
    [0, 0.22].forEach((t0) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(170, now + t0);
      osc.frequency.linearRampToValueAtTime(115, now + t0 + 0.16);
      gain.gain.setValueAtTime(0.0001, now + t0);
      gain.gain.exponentialRampToValueAtTime(0.35, now + t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t0 + 0.17);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + t0);
      osc.stop(now + t0 + 0.19);
    });
  } catch {
    /* bỏ qua */
  }
}
